module.exports = __webpack_public_path__ + "img/rentacar.9d8f4fe9.png";